import type { NextPage } from 'next';
import { Layout } from '@kursk/components/Layout/Layout';
import styles from './SingleEvent.module.scss';
import { ContentBlock } from '@kursk/components/ui/ContentBlock/ContentBlock';
import { useSelectSlice } from "@common/redux/selectors/useSelectSlice";
import { eventSlice } from "@common/redux/slices/event.slice";
import { TimetableBlock } from "@kursk/components/ui/TimetableBlock/TimetableBlock";
import { TimetableList } from "@kursk/components/ui/TimetableList/TimeTableList";
import React, { useRef } from "react";
import { Tags } from "@kursk/components/ui/Tags/Tags";
import { RecommendationsBlock } from "@kursk/components/ui/RecommendationsBlock/RecommendationsBlock";
import { recommendationSlice } from "@common/redux/slices/recommendation.slice";
import { Socials } from "@kursk/components/pages/Home/Socials/Socials";
import { HeaderBlock } from "@kursk/components/ui/HeaderBlock/HeaderBlock";
import { SocialLinks } from "@kursk/components/ui/SocialLinks/SocialLinks";
import { SeoMetaTitles } from "@kursk/components/seo/SeoMetaTitles";
import { LdJson } from "@kursk/components/seo/LdJson";
import { SubscribeFooterForm } from "@kursk/components/ui/SubscribeFooterForm/SubscribeFooterForm";
import { getAddress } from "@kursk/utils/getAddress";
import { FeedbacksBlock } from "@kursk/components/ui/FeedbacksBlock/FeedbacksBlock";
import { PushkinBlockForEntity } from "@kursk/components/ui/PushkinBlockForEntity/PushkinBlockForEntity";

export const SingleEvent: NextPage = () => {
  const { event } = useSelectSlice(eventSlice);
  const { forEventEvents, forEventPlaces } = useSelectSlice(recommendationSlice);
  const timetable = useRef(null);
  const isPushkin = event?.source?.meta?.pushkin;
  if (!event) {
    return <></>;
  }

  return (
    <Layout key={`event_${event._id}`}>
      <LdJson
        entity={event}
        type={'events'}
      />
      <SeoMetaTitles page="singleEvent" entity={{
        name: event.name,
        seo: event.seo,
        address: getAddress(event?.actualSeances?.nearest?.venue?.place?.address ||
          event?.actualSeances?.nearest?.venue?.location?.address),
        placeName: event?.actualSeances?.nearest?.venue?.place?.name ||
          getAddress(event?.actualSeances?.nearest?.venue?.location?.address),
        eventDate: event?.actualSeances?.nearest?.start,
        image: event.image,
      }} showOgImage={true}/>
      <div className={styles.entity}>
        <section className={styles.entity_header}>
          <HeaderBlock
            entityType={'events'}
            entity={event}
            goBack={'/events'}
            goBackTitle={'вернуться к списку событий'}/>
        </section>
        <section className={styles.entity_session}>
          {isPushkin && <PushkinBlockForEntity />}
          {(event?.actualSeances?.nearest || event?.actualSeances?.closest) && (
            <TimetableBlock
              mode={'header'}
              info={event?.actualSeances?.nearest || event?.actualSeances?.closest}
              forRef={timetable}
              entity={event}
              showBuyButton={false}
              entityType='events'
            />
          )}
        </section>
        <section className={styles.entity_share}>
          <SocialLinks/>
        </section>
        <section className={styles.entity_content}>
          <ContentBlock content={event?.content} source={event?.source}/>
        </section>
        {event?.actualSeances?.all?.length > 1 && <section className={styles.entity_timetable}>
          <TimetableList data={event?.actualSeances.all} entity={event} forRef={timetable} withDateFilter />
        </section>}
        <section className={styles.entity_tags}>
          <Tags link={'/events'} className={styles.tags} tags={event?.tags}/>
        </section>
        <section className={styles.entity_feedbacks}>
          <FeedbacksBlock entity={event} entityType={'events'}/>
        </section>
        <section className={styles.entity_subscribeForm}>
          <SubscribeFooterForm/>
        </section>
        <section className={styles.entity_recommendations}>
          <RecommendationsBlock
            entityType="events"
            data={forEventEvents}
            title={'также рекомендуем'}
            goTo={'/events'}
            goToTitle={'все события'}
          />
        </section>
        <section className={styles.entity_recommendations}>
          <RecommendationsBlock
            entityType="places"
            data={forEventPlaces}
            title={'рекомендуем посетить'}
            goTo={'/places'}
            goToTitle={'все места'}
          />
        </section>
        <section className={styles.entity_social}>
          <Socials/>
        </section>
      </div>
    </Layout>
  )
}
